import React, { useMemo } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Avatar, NamedLink } from '../../components';
import { SlBubble } from 'react-icons/sl';
import { FaMapMarkerAlt } from 'react-icons/fa';

import config from '../../config';
import css from './ApplicationPanel.css';

// Custom hook for languages
const useLanguagesData = languages => {
  const languageOptions = config.custom.filters[3].config.options;

  return useMemo(() => {
    if (!languages?.length) return null;

    const keys = languages.map(l => (typeof l === 'string' ? l : l?.language)).filter(Boolean);

    if (!keys.length) return null;

    return keys.map((key, index, arr) => (
      <span key={key}>
        {languageOptions.find(l => l.key === key)?.label || key}
        {index < arr.length - 1 ? ', ' : ''}
      </span>
    ));
  }, [languages, languageOptions]);
};

const SectionProfileCard = ({ user }) => {
  const bio = (
    user?.attributes?.profile?.publicData?.bio ||
    user?.attributes?.profile?.bio ||
    ''
  ).replace(/&nbsp;/g, ' ');
  const displayName = user?.attributes?.profile?.displayName;
  const whoAmI = user?.attributes?.profile?.publicData?.whoAmI || '';
  const languages = user?.attributes?.profile?.publicData?.languages || '';
  const languagesString = useLanguagesData(languages);
  const location = user?.attributes?.profile?.publicData?.location;
  const hasBio = !!bio;

  return (
    <div className={css.profileCard}>
      <div className={css.profileCardHeader}>
        <Avatar user={user} />
        <div className={css.profileCardNameContainer}>
          <NamedLink
            className={css.profileCardDisplayName}
            name="ProfilePage"
            params={{ id: user.id.uuid }}
          >
            {displayName}
          </NamedLink>
          <div className={css.profileCardWhoAmI}>{whoAmI}</div>
        </div>
      </div>

      {/* Hourly Fee Section */}
      <div className={css.profileCardSection}>
        {location && (
          <div className={css.locationContainer}>
            <FaMapMarkerAlt className={css.mapMarkerIcon} />
            <div className={css.locationText}>{location?.search.split(',')[0]}</div>
          </div>
        )}
        {languagesString && (
          <div className={css.languagesContainer}>
            <SlBubble className={css.languageIcon} />
            <div className={css.languagesText}>{languagesString}</div>
          </div>
        )}
      </div>

      {/* Bio Section */}
      {hasBio && (
        <div className={css.profileCardSection}>
          <div className={css.profileCardBody} dangerouslySetInnerHTML={{ __html: bio }} />
        </div>
      )}

      <div className={css.profileCardFooter}>
        <NamedLink className={css.link} name="ProfilePage" params={{ id: user.id.uuid }}>
          <p>
            <FormattedMessage id="ApplicationPanel.viewProfile" />
          </p>
        </NamedLink>
      </div>
    </div>
  );
};

export default SectionProfileCard;
